import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../auth.guard';
// import { HeaderComponent } from '../../app/components/layout/header/header.component';
import { AuthComponent } from './auth.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { RegisterUserComponent } from './register-user/register-user.component';
import { InvalidTokenComponent } from './register-user/invalid-token/invalid-token.component';
import { SuccessComponent } from './register-user/success/success.component';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      { path: 'login', component: LoginComponent },
      {
        path: 'password/reset/:token',
        component: ForgotPasswordComponent,
      },
      {
        path: 'register/:token',
        component: RegisterUserComponent,
      },
      {
        path: 'invalid-token',
        component: InvalidTokenComponent,
      },
      {
        path: 'success',
        component: SuccessComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AuthRoutingModule {}
